var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-img',{attrs:{"contain":"","src":require("@/assets/Virtual Estimate.svg"),"viewBox":"0 0 34 34","width":"34","height":"34"}})
}
var staticRenderFns = []

export { render, staticRenderFns }